/** Публичный Site key dCAPTCHA. Private key живёт только в backend env. */
export const DDG_CAPTCHA_SITE_KEY = '9I0ZI-GGPO-SFM-H8ODSV503CJP9Z0IHWNZ5RH-T';

export const DDG_CAPTCHA_SCRIPT_SRC =
  'https://captcha.ddos-guard.net/static/api.js?render=explicit';

export const DDG_CAPTCHA_REQUIRED_MESSAGE = 'Пройдите проверку CAPTCHA';

const TEST_TOKEN = 'test-captcha-token';

let loadingPromise = null;

export function loadDdgCaptchaApi() {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('CAPTCHA доступна только в браузере'));
  }
  if (window.ddgcaptcha?.render) {
    return new Promise((resolve) => {
      window.ddgcaptcha.ready(() => resolve(window.ddgcaptcha));
    });
  }
  if (loadingPromise) return loadingPromise;

  loadingPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = DDG_CAPTCHA_SCRIPT_SRC;
    script.async = true;
    script.onload = () => {
      if (!window.ddgcaptcha?.ready) {
        loadingPromise = null;
        reject(new Error('CAPTCHA API недоступен'));
        return;
      }
      window.ddgcaptcha.ready(() => resolve(window.ddgcaptcha));
    };
    script.onerror = () => {
      loadingPromise = null;
      reject(new Error('Не удалось загрузить CAPTCHA'));
    };
    document.head.appendChild(script);
  });
  return loadingPromise;
}

export function isDdgCaptchaTestMode() {
  return process.env.NODE_ENV === 'test';
}

export function testCaptchaToken() {
  return TEST_TOKEN;
}
